(function (powerBi, $) {
    /* Set change event handlers for PowerBI embedded groups */
    powerBi.InitPowerBIGroupsChangeHandlers = function () {

        $("[data-status='loading']").hide();

        $(document).on("change", "[data-powerbi-datasetgroupid]", function () {

            $("[data-powerbi-datasetgroupname]").val($("option:selected", this).text());

            var groupId = $(this).val();
            LoadDataSets(groupId);
        });

        $(document).on("change", "[name=BoardType]", function () {
            var groupId = $("[data-powerbi-boardgroupid]").val();
            UpdateDashBoardOrReport(groupId);
        });

        $(document).on("change", "[data-powerbi-boardgroupid]", function () {
            var groupId = $(this).val();
            UpdateDashBoardOrReport(groupId);
        });

        $(document).on("change", "[data-powerbi-board]", function (evt) {
            $('[data-powerbi-boardname]').val($(this).find(':selected').text());
        });

        $(document).on("change", "[data-powerbi-dataset]", function () {
            $("[data-powerbi-datasetname]").val($("option:selected", this).text());
        })
    }

    /* Start a data transfer between a Profit environment and a SQL database */
    powerBi.StartDataTransfer = function (profitEnvironmentKey) {
        const loadStartedMessage = "Handmatige verlading is gestart. Verlaten van dit scherm heeft geen invloed op het verladen.";
        const loadNotStartedMessage = "Handmatige verlading kan niet gestart worden. Probeer het nog een keer en/of neem contact op.";
        $("[data-start-data-transfer-button]").prop('disabled', true);
        globalCore.ShowButtonSpinner($("[data-start-data-transfer-button]"));
        $.ajax({
            url: "/PowerBIEmbedded/StartDataTransfer?ProfitEnvironmentKey=" + profitEnvironmentKey,
            cache: false,
            async: true,
            success: function (data, textStatus, jqXHR) {
                if (data.hasStarted) {
                    $("[data-start-data-transfer-label] span").remove();
                    $("[data-start-data-transfer-label]").append('<span class="badge rounded-pill text-bg-primary">Bezig</span>');
                }
                else {
                    $("[data-start-data-transfer-button]").prop('disabled', false);
                    globalCore.HideButtonSpinner($("[data-start-data-transfer-button]"));
                }
                globalCore.ShowAlert(data.hasStarted, "#alertscontainer", loadStartedMessage, loadNotStartedMessage, false);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                $("[data-start-data-transfer-button]").prop('disabled', false);
                globalCore.HideButtonSpinner($("[data-start-data-transfer-button]"));
                globalCore.ShowAlert(false, "#alertscontainer", null, loadNotStartedMessage, false);
            }
        });
    }

    /* Check if a data transfer from Profit to a SQL database is completed */
    powerBi.IsDataTransferCompleted = function (profitEnvironmentKey) {
        const statusUnknownMessage = "Status van de handmatige verlading kan niet bepaald worden. Probeer het nog een keer en/of neem contact op.";
        $.ajax({
            url: "/PowerBIEmbedded/IsDataTransferCompleted?ProfitEnvironmentKey=" + profitEnvironmentKey,
            cache: false,
            async: true,
            success: function (data, textStatus, jqXHR) {
                if (data.hasErrors) {
                    $("[data-start-data-transfer-label]").append('<span class="badge rounded-pill text-bg-primary">Niet beschikbaar</span>');
                    $("[data-start-data-transfer-button]").prop('disabled', true);
                    globalCore.ShowAlert(false, "#alertscontainer", null, statusUnknownMessage, false);
                    return;
                }
                if (data.isCompleted) {
                    $("[data-start-data-transfer-label]").append('<span class="badge rounded-pill text-bg-primary">Beschikbaar</span>');
                    $("[data-start-data-transfer-button]").prop('disabled', false);
                }
                else {
                    $("[data-start-data-transfer-label]").append('<span class="badge rounded-pill text-bg-primary">Bezig</span>');
                    $("[data-start-data-transfer-button]").prop('disabled', true);
                    globalCore.ShowButtonSpinner($("[data-start-data-transfer-button]"));
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                $("[data-start-data-transfer-label]").append('<span class="badge rounded-pill text-bg-primary">Niet beschikbaar</span>');
                $("[data-start-data-transfer-button]").prop('disabled', true);
                globalCore.ShowAlert(false, "#alertscontainer", null, statusUnknownMessage, false);
            }
        });
    }

    powerBi.InitPowerBiEmbeddedBoardsGrid = function(subscriptionKey) {
        $("#powerBiEmbeddedBoardsGrid").DataTable(datatable.defaultDataTableOptions({
            ajax: {
                url: `/PowerBIEmbedded/SearchPowerBiEmbeddedBoards?subscriptionKey=${subscriptionKey}`
            },
            columns: [
                { data: "boardGroupName", name: "BoardGroupName", title: "Werkruimte rapport", orderable: true, searchable: false },
                { data: "boardType", name: "BoardType", title: "Type", orderable: true, searchable: false },
                { data: "boardName", name: "BoardName", title: "Naam", orderable: true, searchable: false },
                { data: "dataSetGroupName", name: "DataSetGroupName", title: "Werkruimte dataset", orderable: true, searchable: false },
                { data: "dataSetName", name: "DataSetName", title: "Dataset", orderable: true, searchable: false },
                { data: "lastRefresh", name: "LastRefresh", title: "Vernieuwd", defaultContent: "", orderable: true, searchable: false },
                { responsivePriority: -1, defaultContent: "", orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: 5,
                    render: function (data, type, full, meta) {
                        switch (full.refreshStatus) {
                            case "Completed":
                                return `<i class="fa-solid fa-circle-check text-success"></i>&nbsp;${datatable.dutchDateFormat(data, "DD-MM-YYYY HH:mm")}`;
                            case "Failed":
                                return `<i class="fa-solid fa-triangle-exclamation text-warning" data-bs-trigger="hover" data-bs-toggle="popover" data-bs-content="Er is iets fout gegaan tijdens het vernieuwen van de dataset."></i>&nbsp;${datatable.dutchDateFormat(data, "DD-MM-YYYY HH:mm")}`
                            case "InProgress":
                                return `<i class="fa-solid fa-arrows-rotate fa-spin text-info" data-bs-trigger=" hover" data-bs-toggle="popover" data-bs-content="De dataset wordt momenteel vernieuwd."></i>&nbsp;${datatable.dutchDateFormat(data, "DD-MM-YYYY HH:mm")}`
                            default:
                                return`<i class="fa-solid fa-circle-question text-info" data-bs-trigger="hover" data-bs-toggle="popover" data-bs-content="De status van het vernieuwen van de dataset is onbekend."></i>&nbsp;${datatable.dutchDateFormat(data, "DD-MM-YYYY HH:mm")}`
                        }
                    }
                },
                {
                    targets: -1,
                    className: 'text-end text-nowrap',
                    width: '125px',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return `
                        <a class="btn btn-outline-primary fas fa-copy" title="Integratie URL kopiëren" href="#" data-content="URL gekopieerd" data-copytoclipboard="${full.integrationUrl}"></a>
                        <a class="btn btn-outline-primary fas fa-edit" title="Wijzigen" href="/PowerBIEmbedded/DetailsBoard?subscriptionKey=${subscriptionKey}&key=${full.key}" data-bs-toggle="modal" data-bs-target="#modalcontainer"></a>
                        <a class="btn btn-outline-primary fas fa-trash-alt" title="Verwijderen" href="/PowerBIEmbedded/DeleteBoard?subscriptionKey=${subscriptionKey}&key=${full.key}" data-bs-toggle="modal" data-bs-target="#modalcontainer"></a>`;
                    }
                }
            ],
            drawCallback: function () {
                globalCore.InitPopoverInModal();
            }
        }));
    }

    /* Update drop downs for dashboard or reports */
    function UpdateDashBoardOrReport(value) {
        if (value) {
            if ($("#boardType1").is(':checked')) {
                $("[data-dataset-container]").addClass("d-none");
                LoadDashboards(value);
            } else {
                $("[data-dataset-container]").removeClass("d-none");
                LoadReports(value);
            }

            $("[data-powerbi-boardgroupname]").val($("[data-powerbi-boardgroupid]").find(':selected').text());
        }
        else {
            if ($("#boardType1").is(':checked')) {
                $("[data-dataset-container]").addClass("d-none");
                $("[data-powerbi-board]").empty().append($("<option />", { value: "", text: "Selecteer een dashboard" }));
            } else {
                $("[data-dataset-container]").removeClass("d-none");
                $("[data-powerbi-board]").empty().append($("<option />", { value: "", text: "Selecteer een rapport" }));
            }
        }
    }

    /* Fill the dropdown with dashboards */
    function LoadDashboards(value) {

        // Clear the following fields
        $("[data-powerbi-dataset]").val("");
        $("[data-powerbi-datasetgroupid]").val("");
        $("[data-powerbi-datasetgroupname]").val("");
        $("[data-powerbi-datasetname]").val("");

        $("[data-status='loading']").show();
        $.ajax({
            url: "/PowerBIEmbedded/Dashboards",
            cache: false,
            async: true,
            data: {
                groupId: value
            },
            success: function (list) {
                $("[data-powerbi-board]").empty().append($("<option />", { value: "", text: "Selecteer een dashboard" }));
                if (list) {
                    $.each(list, function () {
                        $("[data-powerbi-board]").append($("<option />", { value: this.id, text: this.name }));
                    });
                }
                $("[data-status='loading']").hide();
            }
        });
    }

    /* Fill the dropdown with reports */
    function LoadReports(value) {
        $("[data-status='loading']").show();
        $.ajax({
            url: "/PowerBIEmbedded/Reports",
            cache: false,
            async: true,
            data: {
                groupId: value
            },
            success: function (list) {
                $("[data-powerbi-board]").empty().append($("<option />", { value: "", text: "Selecteer een rapport" }));
                if (list) {
                    $.each(list, function () {
                        $("[data-powerbi-board]").append($("<option />", { value: this.id, text: this.name }));
                    });
                }
                $("[data-status='loading']").hide();
            }
        });
    }

    function LoadDataSets(value) {
        $("[data-status='loading']").show();

        $.ajax({
            url: "/PowerBIEmbedded/DataSets",
            cache: false,
            async: true,
            data: {
                groupId: value
            },
            success: function (list) {
                $dataset = $("[data-powerbi-dataset]");
                $dataset.find("option").not(':eq(0)').remove();

                $.each(list, function () {
                    $dataset.append($('<option>', { value: this.id, text: this.name }));
                });

                $("[data-status='loading']").hide();
            }
        });
    }

}(window.powerBi = window.powerBi || {}, $));
